/**
 * @generated SignedSource<<ebbdec064540fb6e5651c0b2e7466ab6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RepositoryMilestonesInternal$data = {
  readonly nameWithOwner: string;
  readonly viewerCanPush: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"MilestoneList">;
  readonly " $fragmentType": "RepositoryMilestonesInternal";
};
export type RepositoryMilestonesInternal$key = {
  readonly " $data"?: RepositoryMilestonesInternal$data;
  readonly " $fragmentSpreads": FragmentRefs<"RepositoryMilestonesInternal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": "DESC",
      "kind": "LocalArgument",
      "name": "orderDirection"
    },
    {
      "defaultValue": "CREATED_AT",
      "kind": "LocalArgument",
      "name": "orderField"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "state"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "RepositoryMilestonesInternal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanPush",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameWithOwner",
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 50
        },
        {
          "kind": "Variable",
          "name": "orderDirection",
          "variableName": "orderDirection"
        },
        {
          "kind": "Variable",
          "name": "orderField",
          "variableName": "orderField"
        },
        {
          "kind": "Variable",
          "name": "state",
          "variableName": "state"
        }
      ],
      "kind": "FragmentSpread",
      "name": "MilestoneList"
    }
  ],
  "type": "Repository",
  "abstractKey": null
};

(node as any).hash = "63763ba5864de8e315907b0d41b11c95";

export default node;
